export default {
  autoAcceptColor: 'var(--rahalaitos-lighter-dark-green)',
  autoAcceptBg: 'var(--rahalaitos-lightest-green)',
  AutoAcceptCheckpoxMarginTop: '1.5rem',
  disclaimerMargin: '-0.5rem 1.5rem 3rem 3rem;',
};
